<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PA13.w.1.0.0"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PA13"></a>
<div class="gtxt_body" id="block.16.0.0.box.491.541.592.71.q.80" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PA13.w.0.0.0"></a><p class="gtxt_body gtxt_heading" id="para.16.0.0.box.491.541.592.71.q.80" style="text-align:center;">Acknowledgments</p>
</div>
<div class="gtxt_body" id="block.16.1.0.box.141.914.1298.479.q.60">
<a id="ORIG-GBS.PA13.w.1.0.0"></a><p class="gtxt_body" id="para.16.1.0.box.141.914.1298.479.q.60" style="font-size:102%;">It is with warm and grateful thanks that I acknowledge the help so generously given by three fine individuals. My full appreciation goes to good friend Dick Bates for h<a id="GBS.PA13.w.2.0.0"></a>is strong support and encouragement to write this book. For his inspiration and sound advice on how to improve this book, I want to thank retired cavalryman, Col. Leona<a id="GBS.PA14"></a><a id="GBS.PA14.w.0.0.0"></a>rd Lewane. Finally, my warm thanks are extended to Michael Thorpe for his research and many important suggestions for improving this book. To these three gentlemen, I extend my sincerest gratitude.</p>
</div>
</div><div style="display:none;"><a id="GBS.PA15"></a><a id="GBS.PA15.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA15.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA15.w.0.0.0.2"></a></div><div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PA15.w.0.0.0.3"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0009.vue?c994bde2